import { BusClass } from '~/apiClient';

export interface UsePlatformBusClassReturnType {
    getPlatformBusClassesLabel: (busClass: BusClass) => string;
    getMainPlatformBusClassLabel: (busClass: BusClass) => string;
}

export const usePlatformBusClass = (): UsePlatformBusClassReturnType => {
    const { tt } = useTypedI18n();

    return {
        getPlatformBusClassesLabel(busClass): string {
            const platformBusClasses = getPlatformBusClassesFromBusClass(busClass);

            return platformBusClasses.map(pbc => tt(`asset.class.${pbc}`)).join(', ');
        },

        getMainPlatformBusClassLabel(busClass): string {
            const mainPlatformBusClass = getMainPlatformBusClassFromBusClass(busClass);

            return tt(`asset.class.${mainPlatformBusClass}`);
        },
    };
};
